import { render, staticRenderFns } from "./UserTaskData.vue?vue&type=template&id=540681be&scoped=true"
import script from "./UserTaskData.vue?vue&type=script&lang=js"
export * from "./UserTaskData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540681be",
  null
  
)

export default component.exports